import React from 'react';
import {
  Box,
  Typography,
  Button,
  Stack
} from '@mui/material';
import Navigation from './Navigation';
import { GeneratePdfHandler } from './GeneratePdfHandler';
import { GenerateBinderFile } from './GenerateBinderFile';
import RegisterStat from './RegisterStat';

const GeneratePdfPage = ({ data, onBack, onGoTo }) => {

  // Destructure the data object to get the necessary fields
  const { documents } = data;

  // If there are no documents, show a message and a button to go back
  if (!documents || documents.length === 0) {
    return (
      <Box>
        <Typography variant="body2" color="error">
          No documents found. Please add documents before continuing.
        </Typography>
        <Button variant="outlined" onClick={() => onGoTo('start')} sx={{ mt: 2 }}>
          Back
        </Button>
      </Box>
    );
  }

  const handleGenerateBinderFile = () => {
    GenerateBinderFile({ data: data })
  }

  const handleGeneratePDF = () => {
    GeneratePdfHandler({ data })()
      .then(async ({ stampedPdfBytes, fileId }) => {
        const blob = new Blob([stampedPdfBytes], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${data.title || 'report'}-${fileId}.pdf`;
        link.click();
      });
  }

  return (
    <Box>
      <RegisterStat
        endpoint="https://stats.soliman.nl/register"
        site="binder.soliman.nl"
        app="Binder"
        module="GeneratePDF"
      />
      <Navigation currentKey="generate" onGoTo={onGoTo} />

      {/* Buttons */}
      <Stack spacing={2} sx={{ mt: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGeneratePDF}
        >
          Generate PDF
        </Button>
        <Button variant="outlined" onClick={handleGenerateBinderFile}>Export to .binder file</Button>
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
      </Stack>

    </Box>
  );
};

export default GeneratePdfPage;

